import { createSelector } from 'reselect'

export const selectProjectOutputPath = createSelector(
  [ state => state.project.outputPath ],
  outputPath => outputPath as string
)

export const isProjectEditing = createSelector(
  [ state => state.project.editing ],
  value => value as boolean
)

export const isСreatingTask = createSelector(
  [ state => state.project.loading ],
  loading => loading as boolean
)
